import {FunctionComponent, useState} from 'react';
import FilterSection from '../university-filter/FilterSection';
import HanCheckbox from '../../../utils/HanCheckbox';

export interface FilterChangeEvent {
    levels: string[];
    languages: string[];
    subjectAreas: string[];
}

interface Props {
    levels: string[];
    languages: string[];
    subjectAreas: string[];
    onFilterChange: (e: FilterChangeEvent) => void;
}

const SubjectAreaFilter: FunctionComponent<Props> = ({ levels, languages, onFilterChange, subjectAreas }) => {
    const [selectedLevels, setSelectedLevels] = useState<string[]>([]);
    const [selectedLanguages, setSelectedLanguages] = useState<string[]>([]);
    const [selectedSubjectAreas, setSelectedSubjectAreas] = useState<string[]>([]);

    // sorting function that makes sure other and none are always at the bottom,
    // otherwise sort alphabetically
    const customSort = (a: string, b: string) => {
        const lowerA = a.toLowerCase();
        const lowerB = b.toLowerCase();

        if(lowerA === "other" || lowerA === "none") {
            return 1;
        } else if(lowerB === "other" || lowerB === "none") {
            return -1;
        }

        if(lowerA > lowerB) {
            return 1;
        }

        if(lowerA < lowerB) {
            return -1;
        }

        return 0;
    }

    const toggleValue = (value: string, array: string[]): string[] => {
        const newArray = [...array];
        const index = newArray.findIndex(s => s === value);

        if(index === -1) {
            newArray.push(value);
        } else {
            newArray.splice(index, 1);
        }

        return newArray;
    };

    const toggleLevel = (level: string) => {
        const levels = toggleValue(level, selectedLevels);
        setSelectedLevels(levels);

        onFilterChange({ levels, languages: selectedLanguages, subjectAreas: selectedSubjectAreas });
    };

    const toggleLanguage = (language: string) => {
        const languages = toggleValue(language, selectedLanguages);
        setSelectedLanguages(languages);

        onFilterChange({ levels: selectedLevels, languages, subjectAreas: selectedSubjectAreas });
    };

    const toggleSubjectArea = (area: string) => {
        const areas = toggleValue(area, selectedSubjectAreas);
        setSelectedSubjectAreas(areas);

        onFilterChange({levels: selectedLevels, languages: selectedLanguages, subjectAreas: areas })
    }

    return (
        <div className={'subject-area-filter'}>
            <FilterSection title={'Subject Area'} className={'subject-area-filter__section--no-padding'}>
                { Object.values(subjectAreas).sort(customSort).map(area => (
                    <div className={'filter__checkbox'} key={area}>
                        <HanCheckbox
                            onClick={() => toggleSubjectArea(area)}
                            checked={selectedSubjectAreas.includes(area)} />

                        <span className={'university-filter__text'}>{ area }</span>
                    </div>
                )) }
            </FilterSection>

            <FilterSection title={'Levels'}>
                { Object.values(levels).sort(customSort).map(level => (
                    <div className={'filter__checkbox'} key={level}>
                        <HanCheckbox
                            onClick={() => toggleLevel(level)}
                            checked={selectedLevels.includes(level)} />

                        <span className={'university-filter__text'}>{ level }</span>
                    </div>
                )) }
            </FilterSection>

            <FilterSection title={'Languages'}>
                { Object.values(languages).sort(customSort).map(language => (
                    <div className={'filter__checkbox'} key={language}>
                        <HanCheckbox
                            onClick={() => toggleLanguage(language)}
                            checked={selectedLanguages.includes(language)} />

                        <span className={'university-filter__text'}>{ language }</span>
                    </div>
                )) }
            </FilterSection>
        </div>
    );
};

export default SubjectAreaFilter;
